export default {

 home: {
    title: '首頁',
    login: '登入'
  },
  orderTabs: {
    all: '全部',
    refund: '退款'
  },
  common: {
      captchaError: '圖形驗證碼錯誤',
      useConsumerVoucher: '使用消費券',
  showVoucherToStaff: '請向店員出示電子憑證',
  scanToRedeem: '請使用「商戶通」掃描核銷此券',
      coupon_expired:"該券碼已過期，請重新掃碼",
    scan_again:"重新掃碼",
    strfa:"滾動查看完整協議",
    coupon_already_claimed:"​該券碼已被領取，請重新掃碼",
    all: '全部',
    useNow: "立即使用",
    useMethod: "使用方法",
    cancel: '取消',
    confirm: '確認',
    prompt: '提示',
    loading: '正在加載',
    loadFailed: '加載失敗',
    loginSuccess: '登入成功',
    loggingIn: '正在登入',
    
    pleaseLogin: '請先登入',
    noContent: '這裡還沒有內容喲~',
    loadMore: '正在加載更多...',
    loadedAll: '已經全部加載完畢',
    noMore: '沒有更多了~',
    missingParam: '缺少參數',
    pendingConfirm: '待確認',
    pendingPay: '待支付',
    completed: '已完成',
    refunded: '已退款',
    processing: '處理中',
    refunding: '退款中',
    pendingDelivery: '待發貨',
    pendingVerification: '待核銷',
    verified: '已核銷',
    expired: '已過期',
    partialRefund: '部分退款',
    used: '已使用',
    myOrders: '我的訂單',
    myCoupons: '我的消費券',
    pageOpenFailed: '頁面打開失敗',
    viewOrder: '查看訂單',
    paySuccess: '支付成功',
    more: '更多',
    collapse: '收起',
    notSupportedYet: '暫不支持，敬請期待~',
    mr: '先生',
    ms: '女士'
  },
  auth: {
    welcomeTitle: '發現澳門歡迎你',
    welcomeDesc: '授權登入後請放心使用',
    welcomeDescProtected: '您的資訊將受到保護',
    authorizeLogin: '授權登入',
    authorizationSuccess: '授權成功',
    agreementTitle: '用戶協議',
    agreementConfirmText: '我已閱讀並同意',
    agreementScrollTip: '請先滑動到底部',
    login: {
      appTitle: '發現澳門FindMacau',
      phoneRegister: '手機註冊',
      phoneLogin: '手機登入',
      emailRegister: '郵箱註冊',
      emailLogin: '郵箱登入',
      placeholderPhone: '請輸入手機號碼',
      placeholderEmail: '請輸入郵箱號碼',
      placeholderPassword: '請輸入密碼',
      placeholderCode: '請輸入驗證碼',
      forgetPassword: '忘記密碼',
      sendCode: '發送驗證碼',
      resendAfterSeconds: '{count} 秒後重新發送',
      accountLogin: '帳號登入',
      codeLogin: '驗證碼登入',
      agreementWithApp: '我已閱讀並同意發現澳門',
      termsOfUse: '《使用條款》',
      and: '和',
      privacyPolicy: '《隱私政策》',
      registerNow: '立即註冊',
      retrievePassword: '找回密碼',
      alreadyHaveAccount: '已有帳號？',
      noAccountYet: '還沒帳號？',
      quickLogin: '快速登入',
      quickRegister: '快速註冊',
      thirdPartyLogin: '第三方帳號登入',
      humanVerifyTitle: '人機驗證',
      refreshCaptcha: '點擊刷新驗證碼',
      captchaUpdateHint: '點擊上圖可更新驗證碼',
      toast: {
        phoneEmpty: '手機號碼不能為空',
        phoneInvalidFormat: '請輸入正確的手機號碼格式',
        emailEmpty: '郵箱號碼不能為空',
        emailInvalid: '請輸入有效的郵箱',
        emailFillCorrectly: '請正確填寫郵箱',
        mustAgreeTerms: '必須同意條款才能註冊',
        passwordInvalid: '請輸入有效的密碼',
        passwordRule: '請輸入6-18位字母數字組合的密碼',
        codeInvalid4: '請輸入有效的四位驗證碼',
        codeSentSms: '驗證碼發送成功，請留意短信通知',
        codeSentEmail: '驗證碼發送成功，請留意郵箱通知！',
        passwordUpdated: '密碼修改成功,請重新登入'
      }
    }
  },
  payment: {
    returnAndComplete: '請返回支付寶小程序，點擊完成支付',
      processing: '支付處理中，請稍候...',
  processingTimeout: '支付超时，请稍后再试',
  getPaymentInfoFailed: '支付失败，请重试',
  requestFailed: '请求失败，请重试'
},
  coupon: {
         qrCodeTitle:'消費券二維碼',
      qrCodeTip:'請使用掃描工具掃描二維碼',
        unused: '待使用',
       paused:"暫停發券，請稍後再試",
      used: '已使用',

      expired: '已失效',

      myOrders: '我的訂單',
    todaySoldOut: '今日搶光',
    soldOut: '已搶光',
    termsOfUse: '使用條款',
    details: '詳情',
    bookingWebsite: '預訂網址',
    goOfficialBooking: '點我連至官網預訂',
    otherRules: '活動規則',
    receiveNow: '立即領取',
    receiveSuccess: '領取成功',
    systemPrompt: '系統提示',
    confirmUseQuestion: '確定使用嗎?',
    useTime: '使用時間',
    couponQrTitle: '消費券二維碼',
    showQrToMerchant: '請向商家出示二維碼',
    scanToVerify: '請使用「商戶通」掃描核銷此券',
    couponCode: '券碼',
    couponDetailsLoadFailed: '消費券詳情加載失敗',
    exchange: '兌換',
    inputCouponCode: '請輸入優惠碼',
    exchangeSuccess: '兌換成功',
    couponOrCode: '消費券/優惠碼',
    couponTitle: '消費券',
    qrClosed: '已關閉二維碼',
    detailTitle: '消費券詳情',
    scannerTip: '請將二維碼放入框內',
    cameraStartFailed: '攝像頭啟動失敗:',
    qrNotExpired: '二維碼未過期',
    noCoupons: '暫無消費券',
    pendingPayment: '待付款',
    viewNow: '立即查看',
    afterSales: '售後',
    newArrival: '新到',
    noMoreCoupons: '沒有更多消費券了',
    exchangeSuccess: '兌換成功'
  },
  order: {
    goodsTotal: '商品總價',
    discount: '優惠折扣',
    eVoucher: '電子憑證',
    orderNumber: '訂單編號',
    actualPayment: '實付金額',
    paymentTime: '支付時間',
    contactSupport: '聯繫客服',
    viewCredential: '查看憑證',
    scanMerchantQr: '請掃描商家二維碼',
    writeReview: '寫點評',
    viewReview: '查看評論',
    orderAmount: '訂單金額',
    discountCannotStack: '優惠折扣與支付立減不可疊加',
    paymentMethod: '支付方式',
    wechatPay: '微信支付',
    detail: '明細',
    total: '合計',
    pay: '支付',
    payAmount: '需支付',
    payProcessing: '處理中...',
    payTimeout: '支付超時，請重新支付',
    createOrderFailed: '下單失敗',
    paymentFailed: '支付失敗',
    continuePay: '繼續支付',
    finishedPay: '已完成支付',
    wechatPayGuideLine1: "1.如果未打開微信客戶端或未完成付款，請點擊'繼續支付'；",
    wechatPayGuideLine2: "2.如果已完成，請點擊'已完成支付'；",
    paymentNotCompleted: '你還未完成付款，請完成後再試',
    longPressViewOrder: '長按識別查看訂單',
    click: '點擊',
    backHome: '返回首頁',
    autoRedirectMyOrders: 's 後將自動跳轉至我的訂單',
    merchant: '商戶',
    finish: '完成',
    paidSuccess: '付款成功',
    orderDetail: '訂單詳情',
    payResult: '支付結果',
    alipay: '支付寶',
    alipayMacau: '支付寶（澳門）',
    bocWechatPay:"微信支付",
    alipayBOC: '支付寶',
    mpay: 'MPay',
    bocPay: 'BOC Pay',
    creditCardPay: '信用卡支付',
    icbcEpay: '工銀E支付',
    icbcCreditCardPay: '工銀信用卡支付',
    taiFungPay: '豐付寶'
  },
  qrcodepay: {
    followFindMacauOfficial: '關注「發現澳門」微信公眾號',
    moreExcitingAwait: '更多精彩等著您!',
    longPressScanQr: '長按識別二維碼',
    follow: '關注',
    findMacau: '發現澳門',
    officialAccountDesc: '公眾號，新鮮城事搶先知',
    instantDiscount: '滿{base}立減￥{amount}',
    myMiniProgram: '我的小程序'
  },
  share: {
    homeTitle: '澳門旅遊及活動體驗預訂',
    homeDesc: '一網打盡門票、餐券、酒店、上網，當地超值折扣，最低1折起！',
    couponTitle: '噓！送你一疊澳門吃喝玩樂旅遊體驗預訂消費券',
    couponDesc: '不多也就價值1000元+，記得先領券再出發！'
  },
   scan: {
    putQrCodeInFrame: '將二維碼放入框內',
    openingCamera: '正在開啟攝影機...',
    cameraErrorTitle: '無法使用攝影機',
    cameraErrorText: '無法使用攝影機',
    reopen: '重新開啟',
    scanning: '正在掃描二維碼...',
    closeFlash: '關閉閃光燈',
    openFlash: '開啟閃光燈',
    torchNotSupported: '目前裝置不支援閃光燈'
  },
     title: {
      order: '消費券訂單列表',
      orderDetail: '消費券訂單詳情',
      payment: '提交支付',
      paySuccess: '支付成功',
      couponDetail: '消費券詳情',
      couponList: '消費券列表'
    }

}



// WEBPACK FOOTER //
// ./src/i18n/locales/zh_TW.js